module.exports = __webpack_public_path__ + "img/lumpy-space-princess.58b357d8.png";